import React, { Component, PropTypes } from 'react';
import axios from 'axios';
import { Col, ControlLabel, FormGroup } from 'react-bootstrap';
import config from '../../../config/config';

const appUrlPath = `/${config.appUrlPath}`;

class Usage extends Component {
  constructor(props) {
    super(props);
    this.state = {
      option: []
    }
  }

  componentWillMount() {
    axios.get(`${appUrlPath}/getUsage`, {
      params: {}
    })
    .then((res) => {
      this.setState({ option: res.data });
    })
    .catch(() => {
    });
  }

  render() {
    return (
      <FormGroup controlId="usage">
        <Col componentClass={ControlLabel} sm={5}>
          Usage *
        </Col>
        <Col sm={7}>
              <select
                className="custom-select"
                onChange={this.props.handleChangeUsage}
                value={this.props.usage}
                id="usage"
                required
              >
                <option value="">Please Select</option>
                { this.state.option.map((obj, index) => {
                  const counter = index
                  return (
                    <option
                      value={obj.code}
                      key={counter}
                    >{obj.name}</option>
                  );
                })}
              </select>
        </Col>
      </FormGroup>
    )
  }
}

Usage.propTypes = {
  handleChangeUsage: PropTypes.func,
  usage: PropTypes.string
};

export default Usage;



// WEBPACK FOOTER //
// ./src/app/components/usage/Usage.js